import * as React from 'react';
import ContentConstants from '../../contentConstants';
import { IHierarchyReportingAccessConfig } from '../../models/IHierarchyReportingAccessConfig';
import { WarningModal } from '../common';

export interface IHierarchyReportingAccessDeleteModalProps {
	initialModel: IHierarchyReportingAccessConfig;
	isOpen: boolean;
	onClosed: () => void;
	onDelete: (model: IHierarchyReportingAccessConfig) => void;
}

export class HierarchyReportingAccessDeleteModal extends React.Component<IHierarchyReportingAccessDeleteModalProps> {
	public constructor(props: IHierarchyReportingAccessDeleteModalProps) {
		super(props);
		this.closeModal = this.closeModal.bind(this);
		this.saveModal = this.saveModal.bind(this);
	}

	public render() {
		return (
			<WarningModal
				isOpen={this.props.isOpen}
				onClose={this.closeModal}
				onSubmit={this.saveModal}
				contentHeadline={ContentConstants.WARNING_MODAL_DELETE_HEADLINE}
				contentBody={
					'All your data scope and comparison settings for this combination of hierarchy / ' +
					'profile(s) will be deleted. Are you sure you wish to continue?'
				}
			/>
		);
	}

	private closeModal() {
		this.props.onClosed();
	}

	private saveModal() {
		this.props.onDelete(this.props.initialModel);
	}
}
